export enum MDValueTier {
  /** Range 1 */
  Range1 = 1,
  /** Range 2 */
  Range2 = 2,
  /** Range 3 */
  Range3 = 3,
}
